// extracted by mini-css-extract-plugin
export default {"smartMentor":"SmartMentor_smartMentor__nvwlx","iconLogo":"SmartMentor_iconLogo__qxBpc"};